<template>
  <section 
    class="module-popular sg-space"
    :style="{ backgroundColor: sectionBg }"
    :class="modify"
  >
    <headlineCategory
      v-if="showMoreTitle"
      :headlineTitle="context.title"
      :headline-more-title="showMoreTitle?.title"
      :url="showMoreTitle?.url"
      :routing-data="showMoreTitle?.routing_data"
      :type="showMoreTitle?.type"
      :is-app-link="showMoreTitle ? true : false"
      :headlineHomePage="true"
    />
    <headline v-else :headlineTitle="context.title" />
    <div class="container">
      <div class="columns" :class="{ 'mobile-content': isMobile, 'mobile-content-full': seeMore }">
        <div
          v-for="(item, key) in context.items"
          class="column is-4-desktop is-6-tablet is-12-mobile module-popular__item"
          :key="key"
        >
          <app-link
            class="module-popular__container"
            :to="item.url"
            :routing-data="item.routing_data"
            :path-type="item.type"
          >
            <div class="module-popular__counter">{{ ++key }}</div>
            <div class="module-popular__content">
              <div class="module-popular__content--photo">
                <photo-loader
                  :image="item.image"
                  height-skeletor="80"
                  :imgWidth="300"
                  :imgHeight="170"
                />
                <i
                 v-if="item.playable || item.type === 'VIDEO'"
                 class="icon-play-circled module-popular__video"
                ></i>
              </div>
              <div class="module-popular__content--description">
                <span> {{ getArticleTitle(item) }}</span>
              </div>
            </div>
          </app-link>
        </div>
        <div class="module-popular__gradient" v-if="isMobile && !seeMore"></div>
      </div>
      <div class="module-popular__see-more" v-if="isMobile">
        <span class="module-popular__see-more-btn" @click="toggleSeeMore">
          {{ seeMore ? 'ZWIŃ' : 'ROZWIŃ' }}
        </span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useBreakpoint } from '@/composables/useBreakpoints'

import Headline from '@/components/elements/headline.vue'
import headlineCategory from '@/components/elements/headlineCategory.vue'
import AppLink from '@/components/layout/AppLink.vue'
import PhotoLoader from '@/components/elements/PhotoLoader.vue'
import {useUtils} from "@/composables/useUtils";

const { isMobile } = useBreakpoint()

const showMoreTitle = computed(() => props.context?.show_more)

const { getArticleTitle } = useUtils()

const seeMore = ref(false)
const toggleSeeMore = () => {
  seeMore.value = !seeMore.value
}

const props = defineProps({
  context: Object
})

const sectionBg = props.context?.params?.backgroundColor ?? '';
const modify = sectionBg ? 'modify' : '';

</script>

<style lang="scss">
@import '@/assets/scss/components/modules/module-popular.scss';
</style>
